<template>
    <!-- 원청 · 프로젝트 화면 상단 바 — 사내 디자인 시스템 TopNav(compact) 와 같은 모양 · 수치.
         높이 48(관리자 셸의 상단 바와 같은 값 — 두 화면을 오갈 때 아래 좌표가 흔들리지 않는다), 좌우 16, 흰 바탕 + 아래 선.
         3열(1fr auto 1fr)이라 메뉴가 «화면» 가운데 선다. 활성 메뉴는 아래 선(accent), 넘치면 메뉴만 가로 스크롤. -->
    <header class="ds-top-nav">
        <div class="ds-tn-brand">
            <a href="#" class="ds-tn-logo" aria-label="QESG Assessment 홈" @click.prevent="pageGo('', { name: 'Main' })">
                <img src="/images/QESG_Assessment_basic.svg" alt="QESG Assessment">
            </a>
        </div>

        <nav class="ds-tn-menu" aria-label="주 메뉴">
            <a v-for="item in items" :key="item.mode" href="#" class="ds-tn-item"
               :class="{ 'is-active': active_mode === item.mode }"
               :aria-current="active_mode === item.mode ? 'page' : null"
               @click.prevent="pageGo(item.mode, item.to)">{{ item.label }}</a>
        </nav>

        <div class="ds-tn-actions">
            <!-- 좁은 화면에서는 글자를 접으므로 이름을 title · aria-label 로도 단다 -->
            <b-btn v-if="is_admin === 4" :to="{ name: 'ManagingAssessment' }" size="sm" variant="outline-secondary" class="ds-gh-text-btn"
                   title="운영관리" aria-label="운영관리">
                <AppIcon name="settings" class="mr-1"/><span class="ds-tn-label">운영관리</span>
            </b-btn>
            <b-btn v-if="show_ai_manage" :to="{ name: 'ManagingAiAssessment' }" size="sm" variant="outline-secondary" class="ds-gh-text-btn"
                   title="AI 평가 관리" aria-label="AI 평가 관리">
                <AppIcon name="sparkles" class="mr-1"/><span class="ds-tn-label">AI 평가 관리</span>
            </b-btn>
            <DropdownLanguage size="sm" dropdown-variant="outline-secondary" class="ds-tn-lang"/>
            <button type="button" class="ds-gh-icon-btn" aria-label="내 정보 관리" title="내 정보 관리" @click.stop="showMyInfo">
                <AppIcon name="user"/>
            </button>
            <b-btn size="sm" variant="outline-secondary" class="ds-gh-text-btn" @click="logout">로그아웃</b-btn>
        </div>

        <b-modal ref="my-info" size="lg" title="내 정보 관리" hide-footer>
            <user-info></user-info>
        </b-modal>
    </header>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import UserInfo from '@shared_components/utils/UserInfo';
import DropdownLanguage from '@shared_components/utils/dropdown-language';

// 상단 메뉴별 화면. 진행현황 · 기업별 답변 · 평가결과(AdminSubLayout 아래)는 프로젝트 · 캠페인이 같이 써서 admin_mode 를 따른다
const MODE_BY_ROUTE = {
    ProjectCodeList: 'project', ReportBulkRun: 'project', ProjectProgress: 'project',
    CampaignList: 'camp', EditingCampaignAttr: 'camp', CampaignProgress: 'camp',
    TemplateList: 'template', EditingTemplate: 'template', EditingTemplateTranslation: 'template',
    ManagingCriteria: 'template', ManagingParserValues: 'template', StructureEditorDraft: 'template',
};

export default {
    components: {
        UserInfo,
        DropdownLanguage
    },
    computed: {
        ...mapState(['admin_mode']),
        is_admin(){
            return Number(this.$store.getters.isAdmin);
        },
        show_ai_manage(){
            // hmc 한정 조건은 머지 잔재 — sidebar 는 원래 is_admin 만 보므로 정합 맞춤 (2026-09-01 의도 규명)
            return this.is_admin === 3;
        },
        // 활성 메뉴는 화면(라우트)으로 정한다 — 주소로 바로 들어와도 맞게. 프로젝트 · 캠페인이 같이 쓰는 상세 화면만 admin_mode 로
        active_mode() {
            return MODE_BY_ROUTE[this.$route.name] || this.admin_mode;
        },
        // 캠페인 · 질문지는 운영자(레벨 4)만 — 전과 같은 조건
        items() {
            return [
                { mode: 'project', label: '프로젝트 뷰어', to: { name: 'ProjectCodeList' } },
                ...(this.is_admin === 4 ? [
                    { mode: 'camp', label: '캠페인 관리', to: { name: 'CampaignList' } },
                    { mode: 'template', label: '질문지 관리', to: { name: 'TemplateList' } },
                ] : []),
            ];
        },
    },
    created () {
        this.$store.commit('set_view_mode', 'user');
    },
    methods: {
        ...mapMutations(['set_admin_mode']),
        ...mapMutations('score', ['add_all_temp_target_companies']),
        logout(){
            this.$store.dispatch('logout')
                .then(() => { this.$router.push({name:'Login'});  } );
        },
        showMyInfo() {
            this.$refs['my-info'].show();
        },
        pageGo(mode, destination){
            this.set_admin_mode(mode);
            if(mode=='project') this.add_all_temp_target_companies([]);
            if(mode=='camp') this.add_all_temp_target_companies([]);
            this.$store.commit('update_now_page', destination[name]);
            this.$router.push(destination);
        },
    }
};
</script>

<style lang="scss">
.ds-top-nav {
    position: sticky;
    top: 0;
    // 옛 바(bootstrap sticky-top)와 같은 1020 — 이 셸 아래 화면들은 그 값을 전제로 z-index 를 잡았다(예: 기업 답변 상세의 200 짜리 버튼 묶음)
    z-index: 1020;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    gap: 16px;
    height: 48px;
    padding: 0 16px;
    border-bottom: 1px solid var(--ds-border);
    background-color: var(--ds-surface);
}

// 양옆 열이 길어져도 가운데 메뉴가 밀리지 않게 min-width 0 (DS TopNav)
.ds-tn-brand,
.ds-tn-actions {
    display: flex;
    align-items: center;
    min-width: 0;
}

.ds-tn-logo {
    display: flex;
    align-items: center;

    img {
        max-width: 100%;
        max-height: 26px;
    }

    &:focus-visible {
        outline: 2px solid var(--ds-ring);
        outline-offset: 2px;
        border-radius: 2px;
    }
}

// 가운데 정렬은 첫 · 끝 항목의 auto 여백으로 — justify-content: center 는 넘칠 때 왼쪽이 잘려 스크롤로도 못 본다
.ds-tn-menu {
    display: flex;
    align-items: center;
    gap: 4px;
    min-width: 0;
    overflow-x: auto;

    > .ds-tn-item:first-child {
        margin-left: auto;
    }

    > .ds-tn-item:last-child {
        margin-right: auto;
    }
}

// 항목 높이 = 바 높이, 좌우 12, 13px. 활성 = accent 글자 + 아래 선 2(좌우 8 안쪽)
.ds-tn-item {
    position: relative;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    height: 48px;
    padding: 0 12px;
    font-size: 13px;
    white-space: nowrap;
    color: var(--ds-fg-secondary);
    transition: color .15s;

    &:hover {
        color: var(--ds-fg);
        text-decoration: none;
    }

    &.is-active {
        font-weight: 500;
        color: var(--ds-accent-text);

        &::after {
            position: absolute;
            right: 8px;
            bottom: 0;
            left: 8px;
            height: 2px;
            border-radius: var(--ds-radius-badge);
            background-color: var(--ds-accent);
            content: "";
        }
    }

    &:focus-visible {
        outline: 2px solid var(--ds-ring);
        outline-offset: -2px;
    }
}

.ds-tn-actions {
    justify-content: flex-end;
    gap: 8px;
}

// 언어 고르기도 바 안의 텍스트 컨트롤 28
.ds-tn-lang .btn-sm {
    height: 28px;
    padding: 0 10px;
    font-size: 12px;
}

// 1200 미만 — 양옆이 «같은 폭»을 잡을 자리가 없다. 로고 · 버튼은 제 폭을 지키고 메뉴가 남는 폭을 쓴다(넘치면 메뉴만 가로 스크롤)
@media (max-width: 1199.98px) {
    .ds-top-nav {
        grid-template-columns: auto minmax(0, 1fr) auto;
    }

    .ds-tn-actions {
        min-width: auto;
    }
}

// 좁은 화면 — 버튼 글자를 접고 아이콘만(이름은 title 로)
@media (max-width: 991.98px) {
    .ds-tn-label {
        display: none;
    }

    .ds-top-nav .ds-gh-text-btn .app-icon {
        margin-right: 0 !important;
    }
}

// 휴대폰 폭 — 두 줄: 위(로고 · 버튼 48) · 아래(메뉴 40, 넘치면 가로 스크롤). 높이는 언어와 상관없이 88 고정
@media (max-width: 767.98px) {
    // 버튼 묶음이 제 폭을 지키고, 아주 좁으면(360 이하) 로고가 줄어든다
    .ds-top-nav {
        grid-template-columns: minmax(0, 1fr) auto;
        grid-template-rows: 48px 40px;
        row-gap: 0;
        height: auto;
    }

    .ds-tn-menu {
        grid-row: 2;
        grid-column: 1 / -1;
        margin: 0 -16px;
        padding: 0 4px;
        border-top: 1px solid var(--ds-border);
    }

    .ds-tn-item {
        height: 40px;
    }

    .ds-tn-actions {
        grid-row: 1;
        grid-column: 2;
    }
}
</style>
